import React, { useState } from "react";
import { formatNumber } from "../utils/numberUtils";
import { IoLocationSharp } from "react-icons/io5";

const ServicesList = ({ data = [], type = "", condition = true }) => {
  const defaultCarImage = "/car-placeholder.jpg";
  const [imageLoading, setImageLoading] = useState(true);

  // Function to handle image loaded successfully
  const handleImageLoaded = () => {
    setImageLoading(false); // Set image loading state to false when loaded
  };

  return (
    <>
      <div className="card-list">
        {data.map((car, index) => {
          let imageSrc =
            car?.featured_image_url || car?.media?.photo_links[0] || "";

          return (
            <div key={index} className="list-item">
              <a
                href={`/details/?detail_id=${car.id}`}
              >
                <div>
                  <img
                    src={imageSrc} // Load actual car image once available
                    alt="Car"
                    className={`car-image ${imageLoading ? "hidden" : ""}`}
                    onLoad={handleImageLoaded} // Call function when image loads
                    onError={(e) => {
                      e.target.src = defaultCarImage; // Set default image on error
                      setImageLoading(false); // Ensure loading state is turned off
                    }}
                  />
                </div>
              </a>

              <div className="list-content">
              <h3>
  <a
    href={`/details/?detail_id=${car.id}`}
    dangerouslySetInnerHTML={{ __html: car?.title?.rendered }}
  ></a>
</h3>

                {car?.meta?.hp_location && (
                  <div className="car-attr">
                    <span>
                      <IoLocationSharp size={18} />
                      {car?.meta?.hp_location}
                    </span>
                  </div>
                )}
                {car?.meta?.hp_price ? (
                  <span className="car-attr price-tag">
                    ${formatNumber(car?.meta?.hp_price)}/hour
                  </span>
                ) : car?.price ? (
                  <span className="car-attr price-tag">
                    ${formatNumber(car?.price)}/hour
                  </span>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ServicesList;
